/**
 * Presets for scopes plugin.
 * @module
 */

export * as classic from './classic'
